<template>
    <div class="art-cont">
                    <h1 class="fs28 lh38">澳优码助力讲好中国故事 澳门企业荣获世博会首届宝船国际茶文化节“茶科技贡献奖”</h1>
                    <div class="title-info">2022-04-24</div>
                    <div class="main-content">
                        &emsp;&emsp;【本报讯】4月23日，由2020迪拜世博会中华文化馆、中国国家地理·国茶地理主办的首届宝船国际茶文化节(国内部分)于线上成功举办。<br>
<br>
&emsp;&emsp;为助力中国茶文化传播，助推中国茶品牌更好“走出去”，此次活动特别设立“宝船奖”，表彰对中国茶叶出海做出突出贡献的品牌、企业与个人。<br>
<br>
&emsp;&emsp;澳门融贯投资科技有限公司荣获“茶科技贡献奖”，融贯国际依托工信部“星火·链网”骨干节点(珠海横琴)，联合浪潮集团、普华永道等10家机构，推出了“MID码”这一创新型应用，提供一键追溯、质量保障、数字营销、价值反馈等多重服务。<br>
<br>
&emsp;&emsp;科技手段助力茶产业数字化发展<br>
<br>
<p>
	&emsp;&emsp;基于区块链去中心化、数据不可篡改的技术特性，MID码锁定产品生产加工、贸易流通等全生命周期信息的唯一数字身份标识。通过数字身份、一物一码，构建茶叶质量的立体保障体系，让消费者喝到“放心茶”。
</p>
<p>
	<br>
</p>
<p>
	&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<img src="/core/extend/kindeditor/attached/image/20220605/20220605033315_89988.jpg" alt="" ondragstart="return false">&emsp;&emsp;
</p>
<br>
&emsp;&emsp;MID码实时显示大屏(李建宇摄)&emsp;&emsp;<br>
<br>
&emsp;&emsp;目前，MID码已成功应用于多个产品，澳门智慧人文励政会会长吴在权先生联合澳门隆兴澳于今年推出“澳门世遗茶”系列已加入澳优码体系。&emsp;<br>
<br>
<p>
	&emsp;&emsp;“澳门世遗茶”系列将我国具有深厚历史文化底蕴的六堡茶、澳门25处世界文化遗产、传统书法艺术以及区块链技术有机结合，巧妙地展现了国粹文化的创新与应用，为传播中国茶文化创造了一种新的可能性。&emsp;
</p>
<p>
	<br>
</p>
<p>
	<img src="/core/extend/kindeditor/attached/image/20220605/20220605033329_43054.jpg" alt="" ondragstart="return false">
</p>
<br>
&emsp;&emsp;吴在权(李建宇摄)&emsp;&emsp;<br>
<br>
&emsp;&emsp;高端学术论坛，探索中国茶叶未来&emsp;&emsp;<br>
<br>
&emsp;&emsp;下午，中国茶叶迪拜世博会国际分享高端学术论坛如期举行，融贯国际董事长陈祥受邀分享。论坛分为“新发展阶段中，中国茶叶的使命与担当”、“新发展理念下，中国茶叶的高质量发展方向”、“新发展格局下，中国茶叶的新国际化机遇”三个主题，与会专家在线展开积极的讨论。论坛由2020年迪拜世博会中华文化馆茶文化(茶产业)专项委员会秘书长徐浩主持。&emsp;<br>
<br>
<p>
	&emsp;&emsp;陈祥从消费者视角展开了自己的分享，他认为，妨碍中国茶叶走向国际市场的一个重要因素就是标准问题。利用现在流行的区块链技术，完全可以实现茶叶生产全周期的数字化监管与查询，从而助力中国茶叶品牌的提升。而融贯推出的澳优码(UMA)正是基于这种市场需求的设计。&emsp;
</p>
<p>
	<br>
</p>
<p>
	<img src="/core/extend/kindeditor/attached/image/20220605/20220605033338_59826.jpg" alt="" ondragstart="return false">
</p>
<br>
&emsp;&emsp;清华大学珠三角研究院神农数字研究中心执行主任、澳门质量品牌国际认证联盟秘书长围绕澳优码(UMA)应用进行在线分享(李建宇摄)&emsp;&emsp;<br>
<br>
&emsp;&emsp;中国国家地理·国茶地理创始人、中华文化馆总干事惠宣做总结发言，惠宣表示中国茶叶走向世界、参与国际市场竞争是一个面向未来的、长周期的事情，需要文化、科技、产业各界同仁更加广泛的参与和努力。借助宝船国际茶文化节这一平台，我们还有很多的使命要完成。&emsp;&emsp;<br>
<br>
&emsp;&emsp;相约澳门，共迎第二届宝船国际茶文化节&emsp;<br>
<br>
&emsp;&emsp;澳门与内地茶文化同根同源。在中国近代史上，澳门也一直是中国茶叶出口西方的重要港口，可以说澳门与中国茶业发展渊源极深。借助“一国两制”的制度优势，澳门正好可以成为中国茶文化、中国茶品牌出海的第一站。中华文化馆总代表陈钢主席宣布，第二届宝船国际茶文化节举办城市：澳门。<br>
                    </div>
                    <div class="art-bott flex flex-wrap-wrap flex-justify-between flex-align-center">
                        <a href="/News/1" class="art-btn btn-hvr" ondragstart="return false">返回</a>
                        
                    </div>
                    <div class="arc-nav">
                        <a href="/NewsDetail/56" ondragstart="return false">上一条 :  澳獲辦寶船國際茶文化節</a>
                        <a href="/NewsDetail/34" ondragstart="return false">下一条 : 关于我们</a>
                    </div>
                </div>
</template>
  
  <script setup>
  import { ref, onMounted, onUnmounted } from 'vue';
  
  const startAnimate = ref(false)


  onMounted(() => {
    startAnimate.value = true
  });
  
  onUnmounted(() => {
    startAnimate.value = false
  });
  </script>
  
  <style scoped>
 .article .art-cont {
    background: #fff;
    width: calc(70% - 80px);
    padding: 50px 40px;
    overflow: hidden;
    border-radius: 8px;
}
.article .art-cont h1 {
    color: #333;
    font-weight: 700;
}
    .article .art-cont h1 {
        font-size: 26px;
    }

    .article .art-cont .title-info {
        font-size: 14px;
        color: #888;
        font-family: OPPOSans-H;
        padding-left: 30px;
        height: 20px;
        line-height: 22px;
        background: url(@/assets/images/news-time.png) no-repeat left center;
        margin: 30px 0;
    }

    .article .art-bott {
        margin-top: 50px;
        display: flex;
        justify-content: space-between;
        padding-bottom: 30px;
        margin-bottom: 30px;
        border-bottom: 1px solid #f0f0f0;
        align-items: center;
    }
    .article .art-bott .art-btn {
        background: #ea5413;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 110px;
        height: 42px;
        font-weight: 700;
        color: #fff;
        border-radius: 30px;
        transition: all .4s ease;
        font-size: 16px;
    }
    .btn-hvr:hover {
        border-color: transparent;
        box-shadow: 0 0 0 .2rem rgba(234, 84, 19, .5);
    }
    .article .arc-nav a {
        position: relative;
        display: block;
        font-size: 14px;
        color: #666;
        padding-left: 15px;
        transition: all .4s ease;
        font-weight: 700;
    }

  </style>